import { Button, CheckItem, DateField, SelectField, TextField } from 'Components';
import search from 'constants/search';
import { copy } from 'helpers/deep';
import { getMainRoute } from 'helpers/title';
import { cleanSearchParams, urlSearchToObject } from 'helpers/urlSearchParams';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import history from 'src/history';
import './GlobalSearchMobile.css';

const searchRoute = ['jobs', 'templates', 'invoices', 'supplies'];
const normalizeFilterFieldValue = (filter) => {
  if (filter === 'SiteNumber') return 'SiteLocation';
  return filter;
};

class GlobalSearchMobile extends Component {
  constructor(props) {
    super(props);

    const stateFromSearch = urlSearchToObject(history.location.search);

    const formData = Object.assign({}, search.initialFormData, {
      [normalizeFilterFieldValue(props.filterFieldValue)]: props.filterItemValue,
    }, stateFromSearch);

    if (props.isInternalUser) {
      formData.ClientNumber = props.clientNumber;
    }

    const currentRoute = getMainRoute();

    const searchTypes = search.searchType.map(x => ({
      ...x,
      label: i18n.t(`globalSearch:${x.label}`),
    }));

    this.state = {
      searchType: searchRoute.includes(currentRoute) ? currentRoute : 'jobs',
      exactMatch: false,
      formData,
      submissionTypeOptions: [
        ...this.props.submissionTypeOptions,
      ],
      searchOptions: this.props.hasAccessToInvoices
        ? searchTypes
        : searchTypes.filter(x => x.value !== 'invoices'),
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSearchTypeChange = this.handleSearchTypeChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.toggleExact = this.toggleExact.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  toggleExact() {
    this.setState(prevState => ({
      exactMatch: !prevState.exactMatch,
    }));
  }

  handleClear() {
    this.setState({
      formData: search.initialFormData,
    });
  }

  handleFormChange(e) {
    const { name, value } = e.target;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  }

  handleDateChange(field, date) {
    this.handleFormChange({ target: { name: field, value: date } });
  }

  handleSearchTypeChange(e) {
    this.setState({
      searchType: e.target.value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const validSearchTypes = ['jobs', 'templates', 'supplies', 'invoices'];
    const { formData, searchType, exactMatch } = this.state;

    this.props.handleClose();

    if (validSearchTypes.includes(searchType)) {
      const formConfig = copy(search.formConfig[searchType]);
      const relevantSearchParams = formConfig.reduce((acc, item) => {
        if (item.name !== undefined) {
          return {
            ...acc,
            [item.name]: formData[item.name] === '' ? undefined : formData[item.name],
          };
        }
        return acc;
      }, {});

      const searchParams = (
        new URLSearchParams(cleanSearchParams(relevantSearchParams, { searchType, exactMatch })));
      history.push(`/${searchType}?${searchParams.toString()}`);
    }
  }

  render() {
    const formConfigNames = search.formConfig[this.state.searchType].map((obj) => {
      const clientOptions = obj.title === 'Client' ? {
        options: this.props.clientOptions,
      } : {};

      return {
        ...obj,
        title: i18n.t(`globalSearch:${obj.title}`),
        ...clientOptions,
        onChange: this.handleFormChange,
        value: this.state.formData[obj.name],
        maxLength: '200',
      };
    });

    const lastFormConfigName = formConfigNames[formConfigNames.length - 1];

    if (lastFormConfigName.dateType) {
      lastFormConfigName.dateType = lastFormConfigName.dateType.map(x => ({
        ...x,
        label: i18n.t(`globalSearch:${x.label}`),
      }));
    }

    if (lastFormConfigName.selectNumberSix) {
      lastFormConfigName.selectNumberSix = lastFormConfigName.selectNumberSix.map(x => ({
        ...x,
        label: i18n.t(`globalSearch:${x.label}`),
      }));
    }

    if (lastFormConfigName.selectNumberNine) {
      lastFormConfigName.selectNumberNine = lastFormConfigName.selectNumberNine.map(x => ({
        ...x,
        label: i18n.t(`globalSearch:${x.label}`),
      }));
    }

    const domRef = this.props.domRef ? { ref: this.props.domRef } : {};

    return (
      <div className="global-search__mobile" {...domRef}>
        <form className="global-search__mobile__form" onSubmit={this.handleSubmit}>
          <div className="global-search__mobile__container">
            <h1 className="global-search__mobile__main-title">{i18n.t('globalSearch:Search')}</h1>
            <div className="global-search__mobile__search-type">
              <SelectField title={i18n.t('globalSearch:Search Type')} value={this.state.searchType} options={this.state.searchOptions} onChange={this.handleSearchTypeChange} required />
            </div>
            <div className="global-search__mobile__container__grid">
              <div>
                <TextField {...formConfigNames[0]} />
                <TextField {...formConfigNames[1]} />
                <SelectField {...formConfigNames[2]} options={this.state.submissionTypeOptions} />
              </div>
              <div>
                <TextField {...formConfigNames[3]} />
                <TextField {...formConfigNames[4]} />
                <SelectField
                  options={formConfigNames[formConfigNames.length - 1].selectNumberSix}
                  {...formConfigNames[5]}
                />
              </div>
              <div>
                <TextField {...formConfigNames[6]} />
                <TextField {...formConfigNames[7]} />
                <SelectField
                  options={formConfigNames[formConfigNames.length - 1].selectNumberNine}
                  {...formConfigNames[8]}
                />
              </div>
              <div>
                <TextField {...formConfigNames[9]} />
                <TextField {...formConfigNames[10]} />
                <SelectField
                  options={formConfigNames[formConfigNames.length - 1].dateType}
                  {...formConfigNames[11]}
                />
               </div>
              {
                (this.state.searchType === 'jobs') &&
                <div>
                  <TextField {...formConfigNames[12]} />
                  <TextField {...formConfigNames[13]} />
                    <div className="global-search__mobile__container__grid__split">
                      <DateField
                        {...formConfigNames[14]}
                        onChange={this.handleFormChange}
                      />
                      <DateField
                        {...formConfigNames[15]}
                        onChange={this.handleFormChange}
                      />
                    </div>
                </div>
              }
              <div>
                <TextField {...formConfigNames[16]} />
              </div>
              <div>
                <span className="global-search__mobile__container__grid__buttons">
                  <CheckItem checked={this.state.exactMatch} onClick={this.toggleExact} title={i18n.t('globalSearch:Exact Match')} name="exactMatch" />
                  <Button type="button" onClick={this.handleClear} className="button--primary">{i18n.t('globalSearch:Clear')}</Button>
                  <Button type="submit" onClick={() => null} className="button--primary">{i18n.t('globalSearch:Search')}</Button>
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>);
  }
}

GlobalSearchMobile.propTypes = {
  clientOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  submissionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    options: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })),
  hasAccessToInvoices: PropTypes.bool,
  domRef: PropTypes.shape({}),
  handleClose: PropTypes.func,
  filterFieldValue: PropTypes.string,
  filterItemValue: PropTypes.string,
  isInternalUser: PropTypes.bool,
  clientNumber: PropTypes.string,
};

export default GlobalSearchMobile;



// WEBPACK FOOTER //
// ./src/components/GlobalSearch/GlobalSearchMobile/GlobalSearchMobile.jsx